import React from "react";
import PC from "../Pic/Pc.png";
import VID from "../Pic/Video.png";
import BK from "../Pic/Book.png";
import './Intro.css'
function Intro() {
  return (
    <>
      <div className="grid sm:grid-cols-1 md:grid-cols-3 m-4 gap-1 md:gap-2 mt-10 select-none drop-shadow-sm">
        <div className="bg-slate-200 p-10 rounded-tl-3xl rounded-tr-3xl md:rounded-tr-none md:rounded-bl-3xl text-center flex justify-evenly items-center md:flex-col fadein">
          <div>
            <img
              className="w-2/3 h-fit md:w-fit lg:w-3/4 hover:rotate-45"
              src={PC}
              alt="PC"
            />
          </div>
          <div>
            <p className="font-bold text-xl lg:text-3xl hover:italic hover:text-red-300">
              Frontend Developer
            </p>
          </div>
        </div>
        <div className="bg-slate-200 p-10  text-center flex justify-evenly items-center md:flex-col fadein">
          <div>
            <img
              className="w-2/3 h-fit md:w-fit lg:w-3/4 hover:rotate-45 "
              src={VID}
              alt="Camera"
            />
          </div>
          <div>
            <p className="font-bold text-xl lg:text-3xl hover:italic hover:text-red-300">
              Video Editor
            </p>
          </div>
        </div>
        <div className="bg-slate-200 p-10 rounded-bl-3xl rounded-br-3xl md:rounded-tr-3xl md:rounded-bl-none text-center flex justify-evenly items-center md:flex-col fadein">
          <div>
            <img
              className="w-2/3 h-fit md:w-fit lg:w-3/4  hover:rotate-45"
              src={BK}
              alt="Camera"
            />
          </div>
          <div>
            <p className="font-bold text-xl lg:text-3xl hover:italic hover:text-red-300">
              Student
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Intro;
